import { ZendeskApi } from '../../generated/api';
import configuration from './configuration';

export default new ZendeskApi(configuration);
